export const board = {
  title: "掲示板",
  post: "投稿する",
  postModalTitle: "掲示板投稿（無料）",
  quickPost: "クイック投稿",
  freePost: "自由投稿",
  placeholder: "いまどうしてる？",
  empty: "投稿がありません",
  filterEmpty: "条件に一致する投稿が見つかりませんでした",
  online: "オンライン",
  smType: {
    s: "S女",
    m: "M女",
    both: "S女/M女",
  },
  callButton: "発信",
  messageButton: "メッセージ",
  liveButton: "Live",
  postLimit: "5分以内の再投稿はできません",
  postSuccess: "投稿が完了しました！",
  filter: {
    title: "フィルター",
    callWaiting: "通話待機",
    "callWaiting.none": "指定なし",
    "callWaiting.video": "ビデオ",
    "callWaiting.voice": "ボイス",
    age: "年齢",
    "age.none": "指定なし",
    "age.under20": "20歳未満",
    "age.twenties": "20代",
    "age.thirties": "30代",
    "age.forties": "40代",
    "age.fiftyPlus": "50代以上",
    region: "地域",
    "region.none": "指定なし",
    apply: "適用",
    reset: "リセット",
    // Sakura 掲示板のボトムシート用リセット文言（シート内の選択をクリア）
    resetAll: "条件をリセット",
  },
  quickMessages: {
    videoCall: "ビデオ通話しましょう！",
    voiceCall: "音声通話しましょう！",
    callAnytime: "いきなりかけてもらって大丈夫です☆",
    callRequest: "通話リクエストをくれたらかけます♪",
    liveChat: "チャットでお話ししましょう！",
    requestVideo: "動画送って欲しいです^^",
    requestImage: "画像送って欲しいです^^",
  },
  /** Sakura 掲示板の絞り込みタグのラベル */
  tags: {
    all: "すべて",
    videoOk: "ビデオOK",
    voiceOk: "音声OK",
    age20s: "20代",
  },
} as const;
